import { render } from "./user-insert.vue?vue&type=template&id=1bb8a568"
import script from "./user-insert.vue?vue&type=script&lang=js"
export * from "./user-insert.vue?vue&type=script&lang=js"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__